<template>
  <footer id="footer" class="d-flex align-items-center">
    <!-- <div class="ft-transparent"></div> -->
    <div class="container">
      <div class="box-shadow-main footer-container w-100">
        <div class="d-flex flex-wrap justify-content-between align-items-center footer-top">
          <ul class="footer-links">
            <li><router-link to="/general-principle" target="_blank">{{ $t('general_policy') }}</router-link></li>
            <li><router-link to="/privacy-policy" target="_blank">{{ $t('privacy_policy') }}</router-link></li>
            <li><router-link to="/delivery-policy" target="_blank">{{ $t('delivery_policy') }}</router-link></li>
            <li><router-link to="/refund-policy" target="_blank">{{ $t('refund_policy') }}</router-link></li>
          </ul>
          <ul class="btn__social">
            <li><a @click="handleGACustomEvent('IP1_W_1005')" href="https://www.facebook.com/ismart.ecosystem" target="_blank"><img
                  src="/themes/ito/images/social-fb.svg" alt=""></a></li>
            <li><a @click="handleGACustomEvent('IP1_W_1006')" href="https://www.youtube.com/user/DigiClassVietnam" target="_blank"><img
                  src="/themes/ito/images/social-ytb.svg" alt=""></a></li>
            <li><a @click="handleGACustomEvent('IP1_W_1007')" href="https://twitter.com/iSMARTEducatio1" target="_blank"><img
                  src="/themes/ito/images/social-instagram.svg" alt=""></a></li>
          </ul>
        </div>
        <div class="copy-right-txt" v-html="$t('copy_right')"></div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { getMenus } from '../models/menu'
import $ from 'jquery'

export default {
  name: "FooterElement",

  data() {
    return {
      // user: this.$store.getters.user_info,
      menus: [],
      user: {
        name: '',
        fullname: 'Guest',
      }
    };
  },

  computed: {
    ...mapGetters([
      'user_info'
    ], () => {
      if (this.user_info) {
        return this.user_info
      }

      return this.user
    })
  },

  created() {
    this.fetch();
  },

  // updated: function () {
  //   this.$nextTick(function () {
  //     App.init();
  //   })
  // },

  methods: {
    fetch() {

    },
    handleGACustomEvent(element) {
      const user_id = this.user_info.user_id || 0;
      var params = {
        'w_user_id': user_id
      }
      params[element] = user_id
      gtag('event', element, params)
    }

  }
}
</script>

<style scoped>
.footer-container {
  height: auto;
  line-height: normal;
  padding: 12px 20px;
}

.footer-top {
  padding-bottom: 8px;
}

.copy-right-txt {
  white-space: normal;
  line-height: 1.5;
}

.footer-links {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.footer-links li {
  list-style: none;
}

.footer-links li a {
  color: #EC6D43;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}

.footer-links li a:hover {
  text-decoration: underline;
}

.btn__social {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: end;
}
</style>
